import React from 'react';
import { trackCriteoCartView } from '@reverbdotcom/commons/src/criteo';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { MParticlePageName, trackPageView } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { buildCheckoutPageView, fetchCartItems } from '../shared/checkout_events';
import { IUser } from '@reverbdotcom/commons/src/components/user_context_provider';

async function trackCartView(user: Partial<IUser>) {

  const cartItems = await fetchCartItems();

  trackPageView(
    buildCheckoutPageView({
      pageName: MParticlePageName.Cart,
      cartItems,
      user,
    }),
  );

  const items = cartItems.map(item => ({
    id: item.product_id.toString(),
    price: item.item_price.amount,
    quantity: item.quantity || 1,
  }));
  trackCriteoCartView(items, user);
}

export default function TrackCartView() {
  const user = useUser();

  // Only runs once
  React.useEffect(() => {
    trackCartView(user);
  }, [user]);

  return null;
}
